import { render, staticRenderFns } from "./correlation.vue?vue&type=template&id=c1ad8d7e&scoped=true"
import script from "./correlation.vue?vue&type=script&lang=js"
export * from "./correlation.vue?vue&type=script&lang=js"
import style0 from "./correlation.vue?vue&type=style&index=0&id=c1ad8d7e&prod&lang=css"
import style1 from "./correlation.vue?vue&type=style&index=1&id=c1ad8d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad8d7e",
  null
  
)

export default component.exports